module.exports = __webpack_public_path__ + "media/audio8.0344a972.mp3";